<div class="dialog" [ngSwitch]="stepIndex">

    <div class="card" *ngSwitchCase="1">
        <div class="d-flex justify-content-between align-items-center mb-4">
            <div class="logo-image m-0">
                <img src="/assets/images/logo-colored.svg" alt="">
            </div>
            <div class="language d-flex align-items-center">
                <label for="" class="d-flex justify-content-center font-14 font-bold text-nowrap mx-2 color-gray0">{{'assesments.assessment lang' | translate}}</label>
                <ng-select [items]="languages"
                bindLabel="name"
                bindValue="id"
                [(ngModel)]="selectedLang"
                (change)="onChooseLanguage($event)"
                placeholder="Select Language"
                clearable="false"
                class="change-lang"
                [searchable]="false">
                
                <ng-template ng-option-tmp let-item="item">
                    <img [src]="item.img" />
                    {{ item.name | translate }}
                </ng-template>

                <ng-template ng-label-tmp let-item="item">
                    <img [src]="item.img" />
                    {{ item.name | translate }}
                </ng-template>

                </ng-select>
            </div>
        </div>
        
        <p [innerHTML]="'assesments.Introduction one' | translate"></p>

        <div class="title mb-3">{{'assesments.Instructions' | translate}}:</div>
        <p>{{'assesments.Instructions desc' | translate}}</p>

        <ul class="check-list">
            <li>
                <p [innerHTML]="'assesments.Instruction one' | translate"></p>
            </li>
            <li>
                <p [innerHTML]="'assesments.Instruction two' | translate"></p>
            </li>
            <li>
                <p [innerHTML]="'assesments.Instruction three' | translate"></p>
            </li>
        </ul>

        <div class="actions full-width text-center">
            <button class="btn btn-primary w-full" (click)="startTest()" [disabled]="skipLoading">
                {{'form.Start Now' | translate}}
            </button>
            <button class="btn btn-outline-primary w-full" [disabled]="skipLoading" (click)="skipTest()"
                [class.loading]="skipLoading">
                {{'form.Cancel' | translate}}
            </button>
        </div>
    </div>

    <div class="card medium" *ngSwitchCase="2">
        <div class="logo-image left">
            <img src="/assets/images/logo-colored.svg" alt="">
        </div>


        <div *ngIf='dataLoading' class="dataLoading py-5">
            <div class="spinner-border text-primary" role="status">
            </div>
        </div>
        <ng-container *ngIf="!dataLoading">
            <div class="answers-paging">
                <div class="paging">
                    <p> {{'assesments.question' | translate}} <span>{{currentQuestionIndex}}</span>
                        {{'form.of' | translate}} {{questions.length}}
                    </p>
                </div>
                <div class="progress-container">
                    <progress #progressBar id="progressBar" [value]="progressValue" max="100"></progress>
                    @if(lang == 'ar') {
                        <div class="progress-icon" 
                        [style.right]="(currentQuestionIndex != questions.length && lang=='ar') ? iconPosition : ''" 
                        [style.left]="(currentQuestionIndex == questions.length && lang=='ar') ? 0 : ''">
                          <img src="/assets/images/icons/iconamoon_location-pin-fill.svg" alt="">
                        </div>
                    } @else {
                        <div class="progress-icon" 
                        [style.left]="(currentQuestionIndex != questions.length) ? iconPosition : ''" 
                        [style.right]="(currentQuestionIndex == questions.length) ? 0 : ''">
                          <img src="/assets/images/icons/iconamoon_location-pin-fill.svg" alt="">
                        </div>
                    }
                  </div>
                  
            </div>

            <div>
                <div class="question-container">
                    <div class="question-name">
                        {{questions[currentQuestionIndex-1]?.name}}
                    </div>

                    <div class="answers">
                        <div class="answer" *ngFor="let answer of questions[currentQuestionIndex-1]?.anwsers">
                            <p>{{answer.name}}</p>
                            <div>
                                <input type="text" [(ngModel)]="answer.percentage"
                                    (ngModelChange)="calculateRemaining()"
                                    (keydown)="preventSpecialChars($event)"
                                    [ngClass]="{'ng-invalid': hasError(currentQuestionIndex) || isDuplicatePercentage(currentQuestionIndex) || isInvalidPercentage(currentQuestionIndex)}"
                                    [pattern]="numberPattern"
                                    maxlength="2">
                                <span>%</span>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="has-error" *ngIf="isDuplicatePercentage(currentQuestionIndex)">
                                {{'form.has duplicated values' | translate}}
                            </div>
                        </div>
                    </div>

                    <div class="numbers">
                        <div class="total" [ngClass]="{'danger': hasError(currentQuestionIndex)}">
                            {{questions[currentQuestionIndex - 1]?.total || 0}} <span>%</span>
                        </div>
                        <div class="remaining">{{'assesments.Remaining' | translate}}
                            {{questions[currentQuestionIndex - 1]?.total ? 100-(questions[currentQuestionIndex - 1]?.total) : 100}}%</div>
                    </div>
                </div>
            </div>

            <div class="actions same-line">
                <button class="btn btn-outline-primary w-big" (click)="prevQuestion()">
                    <svg class="right" width="6" height="12" viewBox="0 0 6 12" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.705729 1.41537L5.28906 5.9987L0.705729 10.582" stroke="#5252D8"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>

                    {{'pagination.Previous' | translate}}
                </button>
                <button class="btn btn-primary w-big" (click)="nextQuestion()"
                    [disabled]="!validateQuestion() || loading" [class.loading]="loading">
                    @if(currentQuestionIndex == questions.length) {
                    {{'form.Confirm' | translate}}
                    } @else {
                    {{'pagination.Next' | translate}}
                    <svg class="left" width="7" height="12" viewBox="0 0 7 12" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.79427 1.41537L1.21094 5.9987L5.79427 10.582" stroke="white" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                    }
                </button>
            </div>
        </ng-container>
    </div>

    <div class="card medium" *ngSwitchCase="3">
        @if(!loading) {
        <div class="text-center">
            <p class="font-20 mb-2 color-gray0">{{'assesments.Your personality is' | translate}}</p>
            <h2 class="font-32 color-primary font-bold">{{resultInfo.name}}</h2>
            <p class="font-20 color-gray3">{{resultInfo.type_personality}}</p>
            <img class="result-img" [src]="resultInfo.image" alt="">
        </div>

        <div class="actions full-width text-center">
            <button class="btn btn-primary w-full" (click)="getResultPdf()">
                {{'assesments.Get the results' | translate}}
            </button>
            <button class="btn btn-outline-primary w-full" *ngIf="isDefault" (click)="skipResult()">
                {{'popup.Skip now' | translate}}
            </button>
            <a (click)="skipResult()" class="btn btn-outline-primary w-full" *ngIf="!isDefault">
                {{'form.Back' | translate}}
            </a>
        </div>
        } @else {
        <div *ngIf='loading' class="dataLoading py-5">
            <div class="spinner-border text-primary" role="status">
            </div>
        </div>
        }
    </div>
</div>